export default "__VITE_ASSET__Uwd9LnLk__"